// Shared visual tokens for the Watchlist module's new dark-terminal look
// (sampled from the user-provided mockups). Scoped to these 7 pages only —
// the rest of the app keeps its existing design system unchanged.
import type { CSSProperties } from 'react';

export const wl = {
  bg: '#0A0C0A',
  surface: '#0E120E',
  surfaceRaised: '#121712',
  border: '#1C2B1E',
  borderSoft: '#142018',

  green: '#22FF77',
  greenDim: '#16C75A',
  greenWash: '#22FF7714',

  critical: '#FF4C4C',
  criticalWash: '#FF4C4C14',
  high: '#FF8A3D',
  highWash: '#FF8A3D14',
  medium: '#E8B93F',
  mediumWash: '#E8B93F14',
  info: '#4DA3FF',
  infoWash: '#4DA3FF14',

  text: '#DCEFE0',
  textMuted: '#6E8976',
  textFaint: '#3C4F42',

  font: "'JetBrains Mono', ui-monospace, 'SF Mono', Consolas, monospace",
} as const;

export function severityColor(severity: string): string {
  switch (severity) {
    case 'critical': return wl.critical;
    case 'high': return wl.high;
    case 'medium': return wl.medium;
    default: return wl.textMuted;
  }
}

export function classificationColor(classification: string): string {
  switch (classification) {
    case 'official': return wl.greenDim;
    case 'declared_fan': return wl.info;
    case 'impersonation': return wl.high;
    case 'scam_impersonation': return wl.critical;
    default: return wl.textMuted;
  }
}

export const wlPanel: CSSProperties = {
  background: wl.surface,
  border: `1px solid ${wl.border}`,
  borderRadius: 10,
  fontFamily: wl.font,
};

export const wlLabel: CSSProperties = {
  color: wl.textMuted,
  fontSize: 10.5,
  letterSpacing: '0.08em',
  fontWeight: 700,
  fontFamily: wl.font,
};
